<template>
    <div
        class="font-header h-[--navbar-height] fixed bg-sidebar w-full pl-12 pr-8 lg:px-8 lg:ml-[var(--sidebar-width)] border-b border-r border-sidebar-border flex justify-between items-center gap-x-2 z-navbar font-semibold">
        <ButtonPopover :alignEnd="false">
            <template #button>
                <PhQuestion class="size-8 text-primary mt-3" />
            </template>
            <template #content="{ close }">
                <div class="flex flex-col gap-y-1 px-2">
                    <template v-for="page in infoPages" :key="page.id">
                        <Link v-if="!!page.route" @click="() => close()" :href="route(page.route)"
                            class="underline-hover" v-text="page.name" />
                        <button v-else @click="() => actionClicked(page.action, close)"
                            class="underline-hover text-left" v-text="page.name" />
                    </template>
                </div>
            </template>
        </ButtonPopover>
        <div class="flex justify-end items-center xs:gap-x-2 md:gap-x-4 gap-x-1">
            <template v-if="$page.props?.auth?.user">
                <ShortCutPopover />
                <NotificationsPopover />
            </template>
            <template v-else>
                <Link :href="route('register')" class="underline-hover" v-text="$lang.get('Register')" />
                <Link :href="route('login')" class="underline-hover" v-text="$lang.get('Login')" />
            </template>

            <GlobalSearchBar />
        </div>
    </div>
</template>

<script>
import NotificationsPopover from '@/Components/Profile/NotificationsPopover.vue'
import ShortCutPopover from '@/Components/Profile/ShortCutPopover.vue'
import GlobalSearchBar from '@/Components/Search/GlobalSearchBar.vue'
import { PhQuestion } from '@phosphor-icons/vue'
import ButtonPopover from '@/Components/Utilities/ButtonPopover.vue'
import { Link } from '@inertiajs/vue3'

export default {
    components: {
        GlobalSearchBar,
        Link,
        NotificationsPopover,
        ShortCutPopover,
        ButtonPopover,
        PhQuestion,
    },

    props: {},

    data: () => ({
        infoPages: [],
    }),
    created() {
        this.infoPages = [
            { id: 1, route: 'about', name: this.$lang.get('About') },
            { id: 2, route: 'contact', name: this.$lang.get('Contact') },
            { id: 3, route: 'help', name: this.$lang.get('Help & Support') },
            {
                id: 4,
                route: 'terms.show',
                name: this.$lang.get('Terms of Service'),
            },
            {
                id: 5,
                route: 'policy.show',
                name: this.$lang.get('Privacy Policy'),
            },
            {
                id: 6,
                route: 'partners',
                name: this.$lang.get('Partnership')
            }
        ]

        if (this.cookiebotAvailable) {
            this.infoPages.push({
                id: 7,
                action: () => {
                    Cookiebot.renew()
                },
                name: this.$lang.get('Update cookie preferences'),
            })
        }
        // Add a timeout since matomo initilises after a little while
        setTimeout(() => {
            if (this.matomoAvailable) {
                this.infoPages.push({
                    id: 7,
                    action: () => {
                        this.$bus.emit('matomoClearConsentChoice')
                    },
                    name: this.$lang.get('Update tracking preferences'),
                })
            }
        }, 500)
        this.infoPages.push({
            id: 8,
            route: 'attributions',
            name: this.$lang.get('Attributions'),
        })
    },

    computed: {
        matomoConfig() {
            return this?.$page?.props?.matomo
        },

        matomoAvailable() {
            return (
                this.matomoConfig?.host &&
                this.matomoConfig?.site_id &&
                this.$matomo
            )
        },
        cookiebotAvailable() {
            return import.meta.env.VITE_COOKIEBOT_UUID && window.Cookiebot
        },
    },

    methods: {
        actionClicked(action, close) {
            close()
            action()
        },
    },
}
</script>
